import { Component, Input } from '@angular/core';

import { statusProjetadoPerdido } from '../../cliente-analise-mercado-status-projetado';
import { ClienteAnaliseMercadoStatusProjetadoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-projetado-badge-perdido',
    templateUrl: './cliente-analise-mercado-status-projetado-badge-perdido.component.html',
    styleUrls: ['./cliente-analise-mercado-status-projetado-badge-perdido.component.less']
})
export class ClienteAnaliseMercadoStatusProjetadoBadgePerdidoComponent {
    status = statusProjetadoPerdido;

    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusProjetadoPipe: ClienteAnaliseMercadoStatusProjetadoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.clienteAnaliseMercadoStatusProjetadoPipe.transform(this.status.id);
    }
}
